module.exports = __webpack_public_path__ + "img/laminating.bf7c738d.svg";